import React, { FunctionComponent } from 'react';
import { useParams } from 'react-router-dom';
import LegacyView from '../../../../components/legacyView/LegacyView';

const Flight: FunctionComponent = () => {
    const { rideId }: {rideId: string} = useParams();

    return (
        <LegacyView
            path={`/rides/${rideId}/change/info`}
            title={`Ride ${rideId}: Change flight`}
        />
    );
};

export default Flight;
